import Paper from '@mui/material/Paper';
import React from 'react';

const Container = props => (
  <Paper
    square
    sx={{
      backgroundColor: 'grey.700',
      width: theme => theme.mixins.sideNav.width,
      height: '100%',
      position: 'relative',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      zIndex: theme => theme.zIndex.drawer + 1,
      backgroundImage: 'none',
    }}
    {...props}
  />
);

export default Container;
